import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../context/Context.Language";
import {
  LAST_TIME_YOU_STILL_CAN_BOOK,
  RETURN_TIME,
  TEXT_AN_ORDER_NOW,
  TEXT_CREATE,
  TEXT_FAQ,
  TEXT_FIXED_PRICE,
  TEXT_GO_TO_FAQ,
  TEXT_IS_YOUR_PROFESSIONAL,
  TEXT_IS_YOUR_PROFESSIONAL2,
  TEXT_LAUNDRY_SERVICE_BKK,
  TEXT_LAUNDRY_SERVICE_PTY,
  TEXT_MY_LAUNDRY,
  TEXT_MY_LAUNDRY_BACK_SAME_DAY,
  TEXT_PRICING,
  TEXT_PRICING_FIXED,
  TEXT_PRICING_FIXED_TH,
  TEXT_PRICING_FIXED_TH_2,
  TEXT_S_M_L_PRICING,
  TEXT_WANT_TO_KNOW_MORE,
  TEXT_YES_RIGHT_HERE,
  TIME_STRING_ENG,
  TIME_THAT_STILL_SAME_DAY_SERVICE,
} from "../../utils/useConstants";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BODY_2_REGULAR,
  STYLE_BODY_2_REGULAR_XS,
  STYLE_BODY_2_REGULAR_XS_TH,
  STYLE_GRID_HOME_FAQ,
  STYLE_HEADING_2,
  STYLE_IMG_SECTION,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_TITLE_HOME_FAQ,
  STYLE_UNDERLINE_BLUE_24_16,
  STYLE_UNDERLINE_BLUE_SELECTPROGRAM,
} from "../../utils/useStyle";
import { Pricing } from "../faq/render/Faq.List";
import HomeClickToProgram from "../home/functions/Home.ClickToProgram";
import { ENG, TH } from "../home/render/Home.Faq";
import ProgramGoBack from "../task/render/Program.GoBack";
import PricingFirstLoad from "./functions/Pricing.FirstLoad";
import { PricingSize } from "./render/Pricing.Size";
import PricingWater from "./render/Pricing.Water";
import MetaTags from "../../utils/useMetaTags";

const HeadDescription = () => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div className=" md:mt-10 ">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_FIXED_PRICE[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div className={`${STYLE_BODY_2_REGULAR_XS(language)}`}>
        {language === "TH" ? (
          <div>
            {TEXT_PRICING_FIXED_TH[language]}
            <div>{TEXT_PRICING_FIXED_TH_2[language]}</div>
          </div>
        ) : (
          <div>{TEXT_PRICING_FIXED[language]}</div>
        )}
      </div>
    </div>
  );
};

const OurPrograms = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div className=" my-10 md:mt-13.5">
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_S_M_L_PRICING[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div className={`${STYLE_BODY_2_REGULAR_XS(language)}`}>
        {language === "TH" ? (
          <div>
            ไม่ว่าคุณจะเลือก{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Wash",
                //   "6310a054f095c39af2b7503e"
                // )
                navigate("/MyWash")
              }
              className="linkblue cursor-pointer"
            >
              My Wash
            </span>
            ,{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Iron",
                //   "6310a3cff095c39af2b75041"
                // )
                navigate("/MyIron")
              }
              className="linkblue cursor-pointer"
            >
              My Iron{" "}
            </span>
            หรือ{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Shoes",
                //   "6310a3d1f095c39af2b75045"
                // )
                navigate("/MyShoes")
              }
              className="linkblue cursor-pointer"
            >
              My Shoes
            </span>{" "}
            บริการซักผ้าและทำความสะอาดรองเท้าทั้งหมดของเราสามารถปรับเพิ่มตามความต้องการแบบครบวงจร
            สะดวกในการสั่งออเดอร์
            รวดเร็วและง่ายเหมือนการสั่งอาหารหรือซื้อสินค้าออนไลน์
            <div>
              {" "}
              หากมีคำถามอื่นๆ
              <span
                onClick={() => {
                  navigate("/ContactUs");
                }}
                className={`${STYLE_LINK_BLUE}`}
              >
                ติดต่อเรา
              </span>
              หรือ
              <span
                onClick={() => {
                  navigate("/OurServices");
                }}
                className={`${STYLE_LINK_BLUE}`}
              >
                สร้างออเดอร์
              </span>
              ตอนนี้เลย!
            </div>
          </div>
        ) : (
          <div>
            Whether you select{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Wash",
                //   "6310a054f095c39af2b7503e"
                // )
                navigate("/MyWash")
              }
              className="linkblue cursor-pointer"
            >
              My Wash
            </span>
            ,{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Iron",
                //   "6310a3cff095c39af2b75041"
                // )
                navigate("/MyIron")
              }
              className="linkblue cursor-pointer"
            >
              My Iron
            </span>{" "}
            or{" "}
            <span
              onClick={() =>
                // HomeClickToProgram(
                //   navigate,
                //   "My Shoes",
                //   "6310a3d1f095c39af2b75045"
                // )
                navigate("/MyShoes")
              }
              className="linkblue cursor-pointer"
            >
              My Shoes
            </span>{" "}
            our professional laundry service as well as our shoe cleaning
            service are fully customisable to meet all your requirements in a
            one-stop solution. Giving you the utmost flexibility and
            convenience, our services are as easy as ordering food or shopping
            online. In case you have any questions, you can always
            {isMobile ? (
              <div>
                <span
                  onClick={() => {
                    navigate("/ContactUs");
                  }}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  Contact Us
                </span>
                or
                {/* <br /> */}
                <span
                  onClick={() => {
                    navigate("/OurServices");
                  }}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  Create
                </span>
                an order now!
              </div>
            ) : (
              <span>
                <span
                  onClick={() => {
                    navigate("/ContactUs");
                  }}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  Contact Us
                </span>
                or
                <span
                  onClick={() => {
                    navigate("/OurServices");
                  }}
                  className={`${STYLE_LINK_BLUE}`}
                >
                  Create
                </span>
                an order now!
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// export const TEXT_WANT_TO_KNOW_MORE = {
//   EN: "Do you have a laundry service near me? ",
//   TH: "คุณรู้จักร้านซักผ้าใกล้ฉันไหม? ",
// };

const WantToKnowMore = () => {
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div className={`md:mt-13.5 ${STYLE_MAX_WIDTH_DESKTOP}`}>
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {isMobile ? (
          <React.Fragment>
            {language === "TH" ? (
              "คุณรู้จักร้านซักผ้าใกล้ฉันไหม"
            ) : (
              <div>
                <div>Do you have a laundry</div>
                <div>service near me?</div>
              </div>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>{TEXT_WANT_TO_KNOW_MORE[language]}</React.Fragment>
        )}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      <div
        className={`${STYLE_BODY_2_REGULAR(
          language
        )}px-4 md:px-9 xl:px-[250px] text-center `}
      >
        {language === "TH" ? "ใช่" : "Yes,"}
        <span className=" font-semibold mx-1">{TEXT_MY_LAUNDRY[language]}</span>
        {/* <span>{TEXT_IS_YOUR_PROFESSIONAL[language]}</span>
        <div> {TEXT_IS_YOUR_PROFESSIONAL2[language]}</div> */}
        {language === "TH" && (
          <span>
            คือร้านซักผ้าและทำความสะอาดรองเท้าที่ให้บริการในกรุงเทพ
            เรารับประกันว่าทุกออเดอร์ที่สั่งภายใน {LAST_TIME_YOU_STILL_CAN_BOOK}
            :00 น. เราจะไปรับในวันเดียวกันและส่งคืนภายใน {RETURN_TIME}:00 น.
            ของวันถัดไป สะดวกและรวดเร็ว! เร็วกว่านี้ได้ไหม? เฉพาะในกรุงเทพฯ
            แค่เลือกบริการส่งคืนด่วนในวันเดียวกันก่อน{" "}
            {TIME_THAT_STILL_SAME_DAY_SERVICE}:00 น. เราจะไปรับและส่งคืน
            ออเดอร์ภายใน {LAST_TIME_YOU_STILL_CAN_BOOK}:00 น. ของวันเดียวกัน
            <div>
              <span
                className={STYLE_LINK_BLUE}
                onClick={() => {
                  navigate("/OurServices");
                }}
              >
                {TEXT_CREATE[language]}
              </span>
              <span>{TEXT_AN_ORDER_NOW[language]}</span>
            </div>
          </span>
        )}
        {language === "EN" && (
          <span>
            is your professional laundry service and shoe cleaning service in
            Bangkok. We guarantee: All orders placed by{" "}
            {LAST_TIME_YOU_STILL_CAN_BOOK}:00 will be picked up on the same day
            and returned by {RETURN_TIME}:00 the next day - fast & easy! You
            want it faster? In Bangkok only - Activate our Same Day Express
            Service before {TIME_THAT_STILL_SAME_DAY_SERVICE}:00{" "}
            {TIME_STRING_ENG}, and your items will be picked up and returned by{" "}
            {LAST_TIME_YOU_STILL_CAN_BOOK}:00 on the same day.
            <span
              className={STYLE_LINK_BLUE}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </span>
        )}

        {isMobile ? (
          <div>
            <div
              onClick={() => {
                navigate("/Bangkok");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_BKK[language]}
            </div>
            {/* <div
              onClick={() => {
                navigate("/Pattaya");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_PTY[language]}
            </div> */}
          </div>
        ) : (
          <div>
            <span
              onClick={() => {
                navigate("/Bangkok");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_BKK[language]}
            </span>
            {/* <span
              onClick={() => {
                navigate("/Pattaya");
              }}
              className={STYLE_LINK_BLUE + " cursor-pointer"}
            >
              {TEXT_LAUNDRY_SERVICE_PTY[language]}
            </span> */}
          </div>
        )}
      </div>
    </div>
  );
};

const Faq = () => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const [open, setOpen] = React.useState(false);
  const isMobile = useIsMobile();
  // React.useEffect(() => {
  //   if (open) {
  //     FunctionRepleteFont({ language });
  //   }
  // }, [open]);
  return (
    <div className={`${STYLE_GRID_HOME_FAQ} ${STYLE_MAX_WIDTH_DESKTOP}`}>
      {isMobile ? (
        ""
      ) : (
        <img
          src="/images/faq.png"
          className={`${STYLE_IMG_SECTION} mt-[90px]`}
        />
      )}
      <div>
        <div className={`${STYLE_HEADING_2(language)} text-center`}>
          {TEXT_FAQ[language]}
        </div>
        <div className={STYLE_UNDERLINE_BLUE_SELECTPROGRAM}></div>
        {language === "EN" ? (
          <ENG language={language} />
        ) : (
          <TH language={language} />
        )}
        <Pricing
          classNameTitle={`${STYLE_TITLE_HOME_FAQ(language)}`}
          setOpen={setOpen}
          open={open}
        />
        <div className="flex justify-center">
          <div
            onClick={() => navigate("/FAQ")}
            className={`${STYLE_LINK_BLUE} ${
              language === "TH"
                ? " text-sm-th md:text-base-th "
                : " text-sm md:text-base "
            } text-center  w-fit `}
          >
            {TEXT_GO_TO_FAQ[language]}
          </div>
        </div>
      </div>
    </div>
  );
};

const PricingMain = React.memo(({ programs, config, addons }) => {
  const { language } = React.useContext(ContextLanguage);

  useEffect(() => {
    PricingFirstLoad();
  }, []);

  return (
    <div className={`mt-[60px] md:mt-[72px] `}>
      {language === "TH" ? (
        <MetaTags
          title="ราคาซักรีดผ้า กรุงเทพ 🧺👕 เดลิเวอรี่ ฟรี | My Laundry"
          description="ราคาซักรีดในกรุงเทพปกติเท่าไหร่? เราให้บริการซักรีดและทำความสะอาดรองเท้าเดลิเวอรี่แบบมืออาชีพ ด้วยราคาแน่นอน ให้คุณแน่ใจ 🏷 ประหยัดตอนนี้เลย!"
        />
      ) : (
        <MetaTags
          title="Laundry Service Price 🧺👕 FREE Delivery | My Laundry"
          description="How much are laundry services in Bangkok? Our laundry service, ironing service & shoe cleaning service come at fixed prices with no surprises 🏷 Save NOW!"
        />
      )}

      <div
        id="scroll_pricing"
        className={` px-4  md:py-0 md:px-10 xl:px-padding_read md:pt-[40px] ${STYLE_MAX_WIDTH_DESKTOP}  `}
      >
        <ProgramGoBack
          marginarrow="md:ml-9"
          title={TEXT_PRICING[language]}
          textcolor={`${
            language === "TH"
              ? " text-30-th md:text-40-th "
              : " text-30 md:text-40 "
          } `}
        />
        <HeadDescription />
        {/* <OurPrograms /> */}
        <div className="py-4" />
      </div>
      <React.Fragment>
        <PricingSize config={config} programs={programs} addons={addons} />
        <PricingWater config={config} water={addons?.water} />
      </React.Fragment>
      <Faq />
      {/* <WantToKnowMore /> */}
    </div>
  );
});
export default PricingMain;
